import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

import "@/styles/global.scss";

import {
  isDevEnv,
  injectFilters,
  injectInjectables,
  registerDirectives,
} from "@/utils";

import "@/plugins/dayjs";

import keycloak from "@/config/keycloak-config";

Vue.config.productionTip = false;

Vue.config.devtools = isDevEnv();

// Attach the Keycloak instance to Vue's prototype for global access
Vue.prototype.$keycloak = keycloak;

injectInjectables();

/**
 * Registers directives globally in vue
 */
registerDirectives();
injectFilters();

let connecterAppUrl = ''

if(window.location.href && window.location.href.includes('hmac') && window.location.href.includes('shop') && !window.location.href.includes('shopifyState')){
  if(window.location.href.includes('state') ){
    connecterAppUrl = window.location.href.replace('&state=','&shopifyState=')
  }
}

keycloak.init({
  onLoad: "check-sso",  // Automatically checks if the user is already logged in (SSO)
  checkLoginIframe: false,  // Disable periodic login iframe checks for simplicity, this reduces unnecessary requests for login state checks.
  redirectUri : connecterAppUrl ? connecterAppUrl : window.location.href
}).then(() => {
  const hash = window.location.hash; // Gets everything after '#'
  // // If the user is authenticated, mount the Vue application
  if (keycloak.authenticated) {
    // Mount the Vue application
    mountVueApp();
  } else if(hash.includes('error=')) {
    /**
     * If there is an error in the hash, extract it and throw an error
     * This is useful for handling errors that occur during the Keycloak login process
     */
    throw { error: hash?.split('error=')[1]?.split('&')[0] };
  } else {
    keycloak.login({
      redirectUri: `${(window.location.href.includes('shopifyState')||window.location.href.includes('store_domain')) ? window.location.href : process.env.VUE_APP_BASE_URI}`,
    });
  }
}).catch((error) => {
  /**
   * Prepare the query parameters for the authentication route
   * If the error object contains error and error_description, include them in the query
   * Otherwise, leave the query empty
   */
  const query = error?.error ? { 
    error: error.error, 
    error_description: error.error_description 
  } : {};

  // Mount the Vue application even if Keycloak initialization fails
  mountVueApp(); // Mount the app even if Keycloak fails
  setTimeout(() => router.replace({
    path: '/authentication', 
    query
  }));
  console.error('Initialization failed:', error);
})

// Helper function to mount the Vue application
const mountVueApp = () => {
  new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
